import { render, staticRenderFns } from "./PalletRackSpecification.vue?vue&type=template&id=99700adc"
import script from "./PalletRackSpecification.vue?vue&type=script&lang=js"
export * from "./PalletRackSpecification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports